import * as React from 'react';
import classNames from 'classnames';
import styles from './Base.module.css';
export default function Label(props) {
    var _a;
    return (React.createElement("label", { htmlFor: props.for, className: classNames(styles.label, (_a = {},
            _a[styles.labelTop] = props.labelType === 'top',
            _a)), style: props.labelStyle },
        props.label,
        props.required && React.createElement("sup", { className: styles.requiredMark }, "*")));
}
